<script>
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import moment from "moment";
export default {
  mixins: [Api, Sabit],
  props: ["GirisVerileri", "Filter", "OnayDurumu"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
      AddEdit: "",
      FormData: {},
      DonemAktif: false,
      Tarih: moment(new Date()).format('YYYY-MM-DD') ,
      FormDataType: {
        Deger: { FieldName: "Deger", Field: "combobox", FieldTitle: "", ComboDataArray: [], Disabled: false
      },
      },
    };
  },
  watch:{
    OnayDurumu(){ 
      this.FormDataType.Deger.Disabled = this.OnayDurumu
    },
    GirisVerileri(){
      this.Get()


    }
  },
  validations: {
    FormData: {
      Deger: {},
    },
  },
  components: {
    formcombobox,
  },
  methods: {
    kanit_veri_gonder(kontrol) {
      this.$emit("Raporgirisid", null);
      this.$emit("Kontrolgirisid", kontrol);
      this.$emit("OnayDurumu", this.OnayDurumu);
    },

    Get() {

          this.FormData = this.GirisVerileri;
          this.DonemKontrol(this.GirisVerileri.DonemId);
            if (this.GirisVerileri.Id == "00000000-0000-0000-0000-000000000000") {
              this.AddEdit = "Add";
            } else {
              this.AddEdit = "Edit";
            }
            this.FormDataType.Deger.ComboDataArray = []
            this.ActionsSabitGet(1560).then((res) => {
              for (var i = 0; i < res.Data.length; i++) {
                this.FormDataType.Deger.ComboDataArray.push({ Id: res.Data[i].Kod, Value: res.Data[i].Value });
              }
            });




    },
    DonemKontrol(Data){
      this.ActionsSingleGet({
                Service: "strperfdonem",
                Id: Data,
              }).then((res) => {
                  if ( this.$options.filters.formatDate(res.Data.BaslamaTarihi) <= this.Tarih && this.Tarih <= this.$options.filters.formatDate(res.Data.BitisTarihi)) {
                    this.DonemAktif = true;
                    if(this.OnayDurumu == false && this.DonemAktif == true){
                        this.FormDataType.Deger.Disabled = false;
                      }
                      if(this.OnayDurumu == true || this.DonemAktif == false){
                        this.FormDataType.Deger.Disabled = true;
                      }
                  }else{
                    if(this.OnayDurumu == true || this.DonemAktif == false){
                        this.FormDataType.Deger.Disabled = true;
                      }else{
                        this.FormDataType.Deger.Disabled = false;
                      }
                  }

              });
    },
    StrKontrolGiris() {
      if (this.AddEdit == "Add") {
        this.$delete(this.FormData, "Id");
        if(this.FormData.Deger == "" || this.FormData.Deger == null){
        this.FormData.Deger = null;
      }
        this.Post("StrKontrolGiris", this.FormData).then((res) => {
          this.AddEdit = "Edit";
          this.FormData.Id = res.Data;
        });
      } else {
        if(this.FormData.Deger == "" || this.FormData.Deger == null){
        this.FormData.Deger = null;
      }
        this.Update("StrKontrolGiris", this.FormData);
      }
    },
  },
  created() {

  },
};
</script>
<template>
  <td>

    <span  v-show="0">{{ FormDataType.Deger.Disabled }}</span>
    <formcombobox 
    :FormDataType="FormDataType.Deger" 
    :Value="FormData.Deger" 
    :v="$v.FormData.Deger" 
    @input="(FormData.Deger = $event), StrKontrolGiris()"  
    />
    <div class="mb-2" v-if="FormData.Deger == 2 && FormData.Kanitsayisi == 0">Kanıt Girilmedi!</div>
    <b-button class="mx-2" v-tooltip="$t('StrKontrolGiris.AltTable.Aciklama')" v-if="AddEdit == 'Edit'" v-b-modal.StrKontrolGiris @click="$emit('Data', FormData)" variant="outline-info">{{ $t("StrKontrolGiris.AltTable.Aciklama") }}</b-button>
    <b-button class="mx-2" v-if="FormData.Deger > 0 && FormData.Kanitsayisi == 0" v-b-modal.StrKontrolGirisKanit @click="kanit_veri_gonder(FormData.Id)" variant="outline-warning">{{ $t("StrKontrolGiris.AltTable.Kanit") }}</b-button>
    <b-button class="mx-2" v-if="FormData.Deger > 0 && FormData.Kanitsayisi != 0" v-b-modal.StrKontrolGirisKanit @click="kanit_veri_gonder(FormData.Id)" variant="outline-success">{{ $t("StrKontrolGiris.AltTable.Kanit") }}</b-button>
  </td>
</template>
